export default __webpack_public_path__ + "static/media/banner-image_default.95b7b6f0.png";